import { render, staticRenderFns } from "./ModalParametrosCompra.vue?vue&type=template&id=668f9a70&scoped=true"
import script from "./ModalParametrosCompra.vue?vue&type=script&lang=js"
export * from "./ModalParametrosCompra.vue?vue&type=script&lang=js"
import style0 from "./ModalParametrosCompra.vue?vue&type=style&index=0&id=668f9a70&prod&lang=scss&scoped=true"
import style1 from "./ModalParametrosCompra.vue?vue&type=style&index=1&id=668f9a70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668f9a70",
  null
  
)

export default component.exports